import { render, staticRenderFns } from "./ViewVendors.vue?vue&type=template&id=278143c0"
import script from "./ViewVendors.vue?vue&type=script&lang=js"
export * from "./ViewVendors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports